import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClearingHouseComponent } from './clearing-house.component';
const routes: Routes = [ { path: '', component: ClearingHouseComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClearingHouseRoutingModule { }
